var router = [{
  "id": 1,
  "name": "首页配置",
  "path": "",
  "children": [{
    "id": 2,
    "name": "LOGO配置",
    "path": "/indexDisposition/logoDisposition"
  }, {
    "id": 3,
    "name": "游戏配置",
    "path": "/indexDisposition/gameDisposition"
  }, {
    "id": 4,
    "name": "页脚配置",
    "path": "/indexDisposition/footerDisposition"
  }, {
    "id": 5,
    "name": "用户协议",
    "path": "/indexDisposition/userAgreement"
  }, {
    "id": 6,
    "name": "隐私政策",
    "path": "/indexDisposition/privacy"
  }, {
    "id": 7,
    "name": "联系我们",
    "path": "/indexDisposition/contactWay"
  }, {
    "id": 8,
    "name": "图片弹窗配置管理",
    "path": "/indexDisposition/popUpModel"
  }]
}, {
  "id": 8,
  "name": "支付配置",
  "path": "",
  "children": [{
    "id": 12,
    "name": "logo配置",
    "path": "/payment/logo"
  }, {
    "id": 13,
    "name": "banner配置",
    "path": "/payment/banner"
  }, {
    "id": 14,
    "name": "合作配置",
    "path": "/payment/cooperationList"
  }, {
    "id": 15,
    "name": "服务条款",
    "path": "/payment/clauseList"
  }, {
    "id": 16,
    "name": "隐私协议",
    "path": "/payment/PrivacyList"
  }, {
    "id": 17,
    "name": "页脚配置",
    "path": "/payment/footer"
  }, {
    "id": 19,
    "name": "语言配置",
    "path": "/payment/payLang"
  }, {
    "id": 9,
    "name": "游戏列表",
    "path": "/payment/gameList"
  }, {
    "id": 10,
    "name": "服务器列表",
    "path": "/payment/serversList"
  }, {
    "id": 11,
    "name": "商品",
    "path": "/payment/pack"
  }, {
    "id": 24,
    "name": "商品VIP",
    "path": "/payment/packvip"
  }, {
    "id": 18,
    "name": "商品图片列表",
    "path": "/payment/productImageList"
  }, {
    "id": 22,
    "name": "密码修改日志",
    "path": "/payment/passwordLog"
  }, {
    "id": 23,
    "name": "邮箱发送日志",
    "path": "/payment/emaliLog"
  }]
}, {
  "id": 20,
  "name": "订单管理",
  "path": "",
  "children": [{
    "id": 21,
    "name": "订单列表",
    "path": "/order/orderList"
  }]
}];
export default router;